import { FC, memo, useEffect, useState } from "react";
import { StyledMain, StyledMainSection } from "./Main.styled";

import { MainProps } from "./Main.interface";
import { Navigation } from "#/organisms";
import { UserMenu } from "#/molecules";
import { useApi } from "@/api";

const Main: FC<MainProps> = ({ children, navigation, onEditProfile, user }) => {

  const { invoice, order, session, worker } = useApi();

  const [unmaintainedOrdersCount, setUnmaintainedOrdersCount] = useState('0');
  const [unpaidInvoicesCount, setUnpaidInvoicesCount] = useState('0');
  const [orderWithOuttakesCount, setOrderWithOuttakesCount] = useState('0');
  const [orderOfferCount, setOrderOfferCount] = useState('0');

    const getOrderCount = async () => {
      const count = await order.getUnmaintainedList();
      setUnmaintainedOrdersCount(count.toString());
    } 

    const getOuttakesCount = async () => {
      const count = await order.getOrderOuttakesCount();
      setOrderWithOuttakesCount(count.toString());
    }

    const getInvoicesCount = async () => {
      await invoice.getInvoiceCount();
      setUnpaidInvoicesCount(invoice.invoiceCount.toString());
    }

    const getOrderOfferCount = async () => {
      const count = await worker.getOrderOfferCount();
      setOrderOfferCount(count.toString());
    }

    useEffect(() => {
      let interval1, interval2, interval3, interval4;


      if (session.hasAdminRole())
      {
        getOrderCount();
        interval1 = setInterval(getOrderCount, 5e3 * 1e1);
        getOuttakesCount();
        interval2 = setInterval(getOuttakesCount, 6e3 * 1e2);
      }

      if (session.hasCustomerRole() || session.hasAdminRole())
      {
        getInvoicesCount();
        interval3 = setInterval(getInvoicesCount, 9e3 * 1e2);
      }

      if (session.hasWorkerRole())
      {
        getOrderOfferCount();
        interval4 = setInterval(getOrderOfferCount, 9e3 * 1e2);
      }

      return () => {
        interval1 && clearInterval(interval1);
        interval2 && clearInterval(interval2);
        interval3 && clearInterval(interval3);
        interval4 && clearInterval(interval4);
      }
    }, []);

  return (
    <StyledMain>
      <Navigation {...navigation} 
            unmaintainedOrdersCount={unmaintainedOrdersCount} 
            unpaidInvoicesCount={unpaidInvoicesCount}
            orderWithOuttakesCount={orderWithOuttakesCount}
            orderOfferCount={orderOfferCount}
            />
      <StyledMainSection>
        <UserMenu firstName={user.firstName} lastName={user.lastName} onLogout={navigation.onLogout} onEditProfile={onEditProfile} />
        {children}
      </StyledMainSection>
    </StyledMain>
  );
}

export default memo(Main);